export default __webpack_public_path__ + "static/media/clocked-in.48ef34f3.svg";